import React from 'react'
import PropTypes from 'prop-types'

const JobConversationTitle = ({ url, title, invitationUrl = '' }) => (
  <div>
    3D Project:
    <a href={invitationUrl || url} className="u-ml10">{title}</a>
  </div>
)

JobConversationTitle.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  invitationUrl: PropTypes.string,
}

export default JobConversationTitle
